import React from "react";
import { degrees, PDFDocument, rgb, StandardFonts, download } from "pdf-lib";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import { Button, IconButton } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import moment from 'moment';
import { useState, useEffect } from "react";
import Loader from "react-loader-spinner";
import { serverApi , parseDate} from "../../../../global/globalFunctions";

import {

    FormGroup,
    Label,
    Input,
    Collapse,
    InputGroup,
    InputGroupAddon,
    InputGroupText
} from "reactstrap";
import { isEmpty, isNumber, remove } from "lodash";

import { IndeterminateCheckBoxOutlined } from "@material-ui/icons";
import Alert from "@material-ui/lab/Alert";

import {
    postData,
    childSupportAgreed,
    childSupportPayable,
    childSupportFactorPay,
    childSupportRevised,
    childSupportFactor,
    childSupportTax,
    childSupportParentPay,
    childSupportContOption,
    childSupportSpecialCircumstance,
    childSupportTimeShare,
    childSupportEqualCustody,
    childSupportChildMedicalOther,
    childSupportOtherSpecify,
    childSupportGetAllData,
} from "../nonGuideLineChildSupport/NonGuideLine.actions";


const NonGuideLineChildSupport = (props) => {

    const petitionerDetails = props.petitioner;
    const respondentDetails = props.respondent;
    const courtDetails = props.court;


    const useStyles = makeStyles((theme) => ({
        root: {
            width: '100%',
        },
        button: {
            marginTop: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        actionsContainer: {
            marginBottom: theme.spacing(2),
        },
        resetContainer: {
            padding: theme.spacing(3),
        },
    }));

    useEffect(() => {
        props.postData({ divorce_id: window.localStorage.getItem("divorce_id") });
        props.childSupportGetAllData({ divorce_id: window.localStorage.getItem("divorce_id") });

    }, []);


    async function myFunction() {
        const existingPdfBytes = await fetch(`${serverApi}/FL-342(a)`, {
            headers: {
                Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
            },
        }).then((res) => res.arrayBuffer());

        var bytes = new Uint8Array(existingPdfBytes);
        const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
        const form = pdfDoc.getForm();
        props.stipulation.agreed == "0" ? form.getCheckBox("below").check() : props.stipulation.agreed == "1" ? form.getCheckBox("above").check() : form.getCheckBox("above").uncheck() && form.getCheckBox("below").uncheck();

        !isEmpty(props.stipulation.amount) ? form.getField("money").setText(props.stipulation.amount) : form.getField("money").setText("")
        if ((props.stipulation.amount != "0") || (props.stipulation.agreed != "-1")) {
            form.getCheckBox("stipulation").check();
        } else {
            form.getCheckBox("stipulation").uncheck();
        }


        form.getCheckBox("support").check();

        props.childSupportCalculate.agreed == "0" ? form.getCheckBox("pet").check() : props.childSupportCalculate.agreed == "1" ? form.getCheckBox("defendent").check() : form.getCheckBox("defendent").uncheck() && form.getCheckBox("pet").uncheck()


        !isEmpty(props.stipulation.amount) && form.getField("moneyT").setText(props.stipulation.amount)

        props.supportFactor.agreed == "1" ? form.getCheckBox("decrease").check() : props.supportFactor.agreed == "0" ? form.getCheckBox("increase").check() : form.getCheckBox("decrease").uncheck() && form.getCheckBox("increase").uncheck()

        !isEmpty(props.supportFactor.amount) && form.getField("moneyTh").setText(props.supportFactor.amount)

        props.unjustCase.amount == "0" ? form.getCheckBox("until").check() : props.unjustCase.amount == "1" ? form.getCheckBox("further").check() : form.getCheckBox("further").uncheck() && form.getCheckBox("until").uncheck();
        if (form.getCheckBox("until").isChecked()) {
            !isEmpty(props.unjustCase.date) && form.getField("untilDate").setText(parseDate(props.unjustCase.date))
        }

        !isEmpty(props.propertyTaxPay.amount) && form.getField("moneyF").setText(props.propertyTaxPay.amount)

        if (!isEmpty(props.propertyTaxPay.amount) && (props.propertyTaxPay.amount != "0")) {
            form.getCheckBox("factorO").check();
        } else {
            form.getCheckBox("factorO").uncheck();
        }

        props.parentTaxPay.amount == 1 ? form.getCheckBox("factorT").check() : form.getCheckBox("factorT").uncheck()


        props.ContOption.agreed == "1" ? form.getCheckBox("factorTh").check() : form.getCheckBox("factorTh").uncheck();
        if (form.getCheckBox("factorTh").isChecked()) {
            props.ContOption.whoIs == "0" ? form.getCheckBox("petit").check() : form.getCheckBox("respon").check();
        } else {
            form.getCheckBox("petit").uncheck()
            form.getCheckBox("respon").uncheck();
        }
        if (props.circumstanceSpecial.amount == 1) {
            form.getCheckBox("factorF").check();
        } else if (props.circumstanceSpecial.amount == 0) {
            form.getCheckBox("factorF").uncheck();
        } else {
            form.getCheckBox("factorF").uncheck();
        }



        if (form.getCheckBox("factorF").isChecked() && props.childTimeShare.amount == "1") {
            form.getCheckBox("timeSharing").check()
        } else if (form.getCheckBox("factorF").isChecked() && props.childTimeShare.amount == "0") {
            form.getCheckBox("timeSharing").uncheck()
        } else {
            form.getCheckBox("timeSharing").uncheck()
        }

        if (form.getCheckBox("factorF").isChecked() && props.childEqualCustody.amount == "1") {
            form.getCheckBox("substantially").check()
        } else if (form.getCheckBox("factorF").isChecked() && props.childEqualCustody.amount == "0") {
            form.getCheckBox("substantially").uncheck()
        } else {
            form.getCheckBox("substantially").uncheck()
        }


        if (form.getCheckBox("factorF").isChecked() && props.childMedicalOpt.agreed == "1") {
            form.getCheckBox("medical").check()
        } else if (form.getCheckBox("factorF").isChecked() && props.childMedicalOpt.agreed == "0") {
            form.getCheckBox("medical").uncheck()
        } else {
            form.getCheckBox("medical").uncheck()
        }


        if (form.getCheckBox("medical").isChecked() && !isEmpty(props.childMedicalOpt.amount)) {
            form.getField("text").setText(props.childMedicalOpt.amount)
        } else if (form.getCheckBox("medical").isChecked() && isEmpty(props.childMedicalOpt.amount)) {
            form.getField("text").setText("")
        } else {
            form.getField("text").setText("")
            form.getCheckBox("medical").uncheck()

        }


        // if (form.getCheckBox("factorF").isChecked() && props.otherOpt.agreed == "1") {
        //     form.getCheckBox("otherCode").check()
        // } else if (form.getCheckBox("factorF").isChecked() && props.otherOpt.agreed == "0") {
        //     form.getCheckBox("otherCode").uncheck()
        // } else {
        //     form.getCheckBox("otherCode").uncheck()
        // }

        // if (form.getCheckBox("otherCode").isChecked() && !isEmpty(props.otherOpt.amount)) {
        //     form.getField("specify").setText(props.otherOpt.amount)
        // } else {
        //     form.getField("specify").setText("")
        // }

        form.getCheckBox("factorF").check()
        form.getCheckBox("otherCode").check()
        form.getField("specify").setText("The parties stipulated to a different amount of child support. Family Code Section 4057(b)(1).")

        form.getField("petitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
        form.getField("respondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
        form.getField("caseNumber").setText(courtDetails.caseNumber.toString());

        form.getCheckBox("child").check()
        // form.flatten();
        const pdfBytes = await pdfDoc.save();
        const pdfDataUrl = URL.createObjectURL(
            new Blob([pdfBytes], { type: "application/pdf" })
          );
          window.open(pdfDataUrl, "_blank");


    }
    function saveByteArray(reportName, byte) {
        var blob = new Blob([byte], { type: "application/pdf" });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var fileName = reportName;
        link.download = fileName;
        link.click();
    }


    const [isNonGuideOne, setNonGuideOne] = useState(false);
    const [isNonGuideTwo, setNonGuidetwo] = useState(false);
    const [isNonGuideThree, setNonGuideThree] = useState(false);
    const [isNonGuideFour, setNonGuideFour] = useState(false);
    const [isNonGuideFive, setNonGuideFive] = useState(false);
    const [isNonGuideSix, setNonGuideSix] = useState("-1");
    const [isNonGuideSeven, setNonGuideSeven] = useState(false);
    const [isNonGuideEight, setNonGuideEight] = useState(false);
    const [isNonGuideNine, setNonGuideNine] = useState("-1");
    const [isNonGuideTen, setNonGuideTen] = useState(false);
    const [isNonGuideEleven, setNonGuideEleven] = useState(false);


    function getSteps() {
        return [
            'Stipulation to non-guideline order',
            'Support calculation',
        ];
    }

    function getStepContent(step) {
        switch (step) {
            case 0:
                return (
                    <div>
                        {/* Q1 Started */}
                        <FormGroup>
                            <Label for="exampleSelect">
                                The child support agreed to by the both parties through the statewide child support guidelines is
                            </Label>
                            <Input
                                defaultValue={props.stipulation.agreed}
                                type="select"
                                name="married"
                                id="childsupport"
                                onChange={(e) => setNonGuideOne(JSON.parse(e.target.value))}
                            >
                                <option selected value="-1">
                                    {" "}
                                    -- Select an option --{" "}
                                </option>
                                <option value="0" >Below</option>
                                <option value="1">Above</option>
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label for="exampleSelect">The amount of guideline  child support per month payable</Label>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>$</InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    defaultValue={
                                        Number(props.stipulation.amount)
                                    }
                                    type="number"
                                    name="married"
                                    id="below"
                                >

                                </Input>
                            </InputGroup>
                        </FormGroup>
                    </div>
                );

            case 1:
                return (
                    <div>
                        <div style={{ marginBottom: "30px" }}>
                            {/* Q2 Started */}
                            <FormGroup>
                                <Label for="exampleSelect">
                                    <Typography variant="h5"></Typography>
                                    <b style={{ paddingRight: "7px" }}>(a) </b>  The guideline amount of child support calculated per month payable by
                                </Label>
                                <Input
                                    defaultValue={props.childSupportCalculate.agreed}
                                    type="select"
                                    name="married"
                                    id="childsupportpayable"
                                    onChange={(e) => setNonGuidetwo(JSON.parse(e.target.value))}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value="0" >Petitioner</option>
                                    <option value="1" >Respondent</option>
                                </Input>
                            </FormGroup>
                            {/* <FormGroup>
                                <Label for="exampleSelect">The guideline amount of child support per month payable is</Label>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        defaultValue={
                                            Number(props.childSupportCalculate.amount)
                                        }
                                        type="number"
                                        name="married"
                                        id="paypetitioner"
                                    >
                                    </Input>
                                </InputGroup>
                            </FormGroup> */}
                        </div>
                        <div style={{ marginBottom: "30px" }}>
                            <FormGroup>
                                <Label for="exampleSelect">
                                    <Typography variant="h5"></Typography>
                                    <b style={{ paddingRight: "7px" }}>(b)</b>  The court finds by a preponderance of the evidence that rebuttal factors exist. The rebuttal factors results child support is
                                </Label>
                                <Input
                                    defaultValue={props.supportFactor.agreed}
                                    type="select"
                                    name="married"
                                    id="supportfactor"
                                    onChange={(e) => setNonGuideThree(JSON.parse(e.target.value))}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value="0">Increase</option>
                                    <option value="1">Decrease</option>
                                </Input>
                            </FormGroup>
                            <FormGroup>
                                <Label for="exampleSelect">The revised amount of support per month payable is  </Label>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        defaultValue={Number(props.supportFactor.amount)}
                                        type="number"
                                        name="married"
                                        id="increase"
                                    >

                                    </Input>
                                </InputGroup>
                            </FormGroup>
                        </div>
                        <div style={{ marginBottom: "30px" }}>
                            <FormGroup>
                                <Label for="exampleSelect">
                                    <Typography variant="h5"> </Typography>
                                    <b style={{ paddingRight: "7px" }}>(c)</b>  These changes remain in effect is
                                </Label>
                                <Input
                                    defaultValue={props.unjustCase.amount}
                                    type="select"
                                    name="married"
                                    id="factorrevised"
                                    onChange={(e) => setNonGuideFour(JSON.parse(e.target.value))}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value="0" >Until date</option>
                                    <option value="1"  >Further order</option>
                                </Input>
                            </FormGroup>
                            <Collapse isOpen={isNonGuideFour == "0" ? true : false}>
                                <FormGroup>
                                    <Label for="exampleSelect">Until date : </Label>
                                    <Input
                                        defaultValue={moment(props.unjustCase.date).format('YYYY-MM-DD')}
                                        type="date"
                                        name="married"
                                        id="reviseddate"
                                    >
                                    </Input>
                                </FormGroup>
                            </Collapse>
                        </div>

                        {/* <FormGroup>
                            <Label for="exampleSelect">
                                <Typography variant="h5"></Typography>
                                <b style={{ paddingRight: "7px" }}>(d)</b> <b> Please select which following factors support your non guideline child support agreement:</b>
                            </Label>
                        </FormGroup> */}

                        {/* <div style={{ marginBottom: "30px" }}>
                            <FormGroup>
                                <Label for="exampleSelect">
                                    <Typography variant="h5"></Typography>
                                    <b style={{ paddingRight: "7px" }}>(1)</b>We both agreed to this non-guideline child support amount
                                </Label>
                                <Input
                                    defaultValue={props.otherOpt.agreed}
                                    type="select"
                                    name="married"
                                    id="other"
                                    onChange={(e) => setNonGuideEight(JSON.parse(e.target.value))}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                </Input>
                            </FormGroup>
                            <Collapse isOpen={isNonGuideEight == "1" ? true : false}>
                                <FormGroup>
                                    <b>The parties stipulated to a different amount of child support. Family Code Section 4057(b)(1)</b>
                                </FormGroup>
                            </Collapse>
                        </div> */}
                        {/* <div style={{ marginBottom: "30px" }}>
                            <FormGroup>
                                <Label for="exampleSelect">
                                    <Typography variant="h5"></Typography>
                                    <b style={{ paddingRight: "7px" }}>(2)</b>  The sale of the family residence is deferred under Family Code section 3800, and the rental value of the
                                    family residence in which the children reside exceeds the mortgage payments, homeowners insurance, and
                                    property taxes per month per month by
                                </Label>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>$</InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        defaultValue={Number(props.propertyTaxPay.amount)}
                                        type="number"
                                        name="married"
                                        id="propertytax"

                                    >
                                    </Input>
                                </InputGroup>
                            </FormGroup>
                        </div> */}
                        {/* <div style={{ marginBottom: "30px" }}>
                            <FormGroup>
                                <Label for="exampleSelect">
                                    <Typography variant="h5"></Typography>
                                    <b style={{ paddingRight: "7px" }}>(3)</b>  The parent paying support has extraordinarily high income, and the amount determined under the guideline
                                    would exceed the needs of the child.
                                </Label>
                                <InputGroup>
                                    <Input
                                        defaultValue={props.parentTaxPay.amount}
                                        type="select"
                                        name="married"
                                        id="parentpay"

                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value="0">No</option>
                                        <option value="1">Yes</option>
                                    </Input>
                                </InputGroup>
                            </FormGroup>
                        </div> */}
                        {/* <div style={{ marginBottom: "30px" }}>
                            <FormGroup>
                                <Label for="exampleSelect">
                                    <Typography variant="h5"></Typography>
                                    <b style={{ paddingRight: "7px" }}>(4)</b> A parent is not contributing to the needs of the children at a level commensurate with that party’s custodial time
                                </Label>
                                <InputGroup>
                                    <Input
                                        defaultValue={props.ContOption.agreed}
                                        type="select"
                                        name="married"
                                        id="contoption"
                                        onChange={(e) => setNonGuideEleven(JSON.parse(e.target.value))}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value="0">No</option>
                                        <option value="1">Yes</option>
                                    </Input>
                                </InputGroup>
                            </FormGroup>
                            <Collapse isOpen={isNonGuideEleven == "1" ? true : false}>
                                <FormGroup>
                                    <Label for="exampleSelect">
                                        <Typography variant="h5"></Typography>
                                        Who is not?
                                    </Label>
                                    <Input
                                        defaultValue={props.ContOption.whoIs}
                                        type="select"
                                        name="married"
                                        id="whocontoption"

                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value="0">Petitioner</option>
                                        <option value="1">Respondent</option>
                                    </Input>
                                </FormGroup>
                            </Collapse>
                        </div> */}
                        {/* <div style={{ marginBottom: "30px" }}>
                            <FormGroup>
                                <Label for="exampleSelect">
                                    <Typography variant="h5"></Typography>
                                    <b style={{ paddingRight: "7px" }}>(5)</b> <b>Special circumstances exist in this case.</b>
                                </Label>
                                <Input
                                    defaultValue={props.circumstanceSpecial.amount}
                                    type="select"
                                    name="married"
                                    id="specialcircumstance"
                                    onChange={(e) => setNonGuideSix(JSON.parse(e.target.value))}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value="0" selected={props.circumstanceSpecial.amount === "0"}>No</option>
                                    <option value="1" selected={props.circumstanceSpecial.amount === "1"}>Yes</option>
                                </Input>
                            </FormGroup>
                        </div> */}
                        {/* <Collapse isOpen={isNonGuideSix == "1" ? true : false}>
                            <div style={{ marginBottom: "30px" }}>
                                <b>The special circumstances are:</b>
                                <FormGroup>
                                    <Label for="exampleSelect">
                                        <Typography variant="h5"></Typography>
                                        <b style={{ paddingRight: "7px" }}>(i)</b> The parents have different timesharing arrangements for different children
                                    </Label>
                                    <Input
                                        defaultValue={props.childTimeShare.amount}
                                        type="select"
                                        name="married"
                                        id="timeshare"
                                        onChange={(e) => setNonGuideNine(JSON.parse(e.target.value))}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value="0" selected={props.childTimeShare.amount === "0"}>No</option>
                                        <option value="1" selected={props.childTimeShare.amount === "1"}>Yes</option>
                                    </Input>
                                </FormGroup>
                            </div>
                            <div style={{ marginBottom: "30px" }}>
                                <FormGroup>
                                    <Label for="exampleSelect">
                                        <Typography variant="h5"></Typography>
                                        <b style={{ paddingRight: "7px" }}>(ii)</b> The parents have substantially equal custody of the children and one parent has a much lower or higher percentage of income used for housing than the other parent
                                    </Label>
                                    <Input
                                        defaultValue={props.childEqualCustody.amount}
                                        type="select"
                                        name="married"
                                        id="equalcustody"
                                        onChange={(e) => setNonGuideTen(JSON.parse(e.target.value))}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value="0">No</option>
                                        <option value="1">Yes</option>
                                    </Input>
                                </FormGroup>
                            </div>
                            <div style={{ marginBottom: "30px" }}>
                                <FormGroup>
                                    <Label for="exampleSelect">
                                        <Typography variant="h5"></Typography>
                                        <b style={{ paddingRight: "7px" }}>(iii)</b> The child has special medical or other needs that require support greater than the formula amount.
                                    </Label>
                                    <Input
                                        defaultValue={props.childMedicalOpt.agreed}
                                        type="select"
                                        name="married"
                                        id="childoptions"
                                        onChange={(e) => setNonGuideSeven(JSON.parse(e.target.value))}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value="0">No</option>
                                        <option value="1">Yes</option>
                                    </Input>
                                </FormGroup>
                                <Collapse isOpen={isNonGuideSeven == "1" ? true : false}>
                                    <FormGroup>
                                        <Label for="exampleSelect">
                                            <Typography variant="h5"></Typography>
                                            These needs are specify
                                        </Label>
                                        <Input
                                            defaultValue={props.childMedicalOpt.amount}
                                            type="textarea"
                                            name="married"
                                            id="childmedicalother"
                                        >
                                        </Input>
                                    </FormGroup>
                                </Collapse>
                            </div>
                        </Collapse> */}


                    </div>
                );


            default:
                return 'Unknown step';
        }
    }

    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    const handleNext = () => {
        handlePostFunc();
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    const handlePostFunc = () => {
        if (activeStep === 0) {
            props.childSupportAgreed({
                divorce_id: window.localStorage.getItem("divorce_id"),
                stipulation: document.getElementById("childsupport").value,
                stipulationFormulla: document.getElementById("below").value,

            })
        } else if (activeStep === 1) {
            props.childSupportPayable({
                divorce_id: window.localStorage.getItem("divorce_id"),
                childSupportCalculate: document.getElementById("childsupportpayable").value,
                supportPayable: "",
                supportFactor: document.getElementById("supportfactor").value,
                supportAmount: document.getElementById("increase").value,
                unjustCase: document.getElementById("factorrevised").value,
                untilDate: document.getElementById("factorrevised").value == "0" ? document.getElementById("reviseddate").value : "",
                // propertytax: document.getElementById("propertytax").value,
                // parentPay: document.getElementById("parentpay").value,
                // contributingOption: document.getElementById("contoption").value,
                // whoIs: document.getElementById("contoption").value == "1" ? (document.getElementById("whocontoption").value) : "",
                // specialCircumstance: document.getElementById("specialcircumstance").value,
                // timeShare: document.getElementById("timeshare").value,
                // equalCustody: document.getElementById("specialcircumstance").value == "1" ? (document.getElementById("equalcustody").value) : "",
                // childSpecialMedical: document.getElementById("childoptions").value,
                // specialMedicalOtherDesc: document.getElementById("childoptions").value == "1" ? (document.getElementById("childmedicalother").value) : "",
                // otherSpecifyId: document.getElementById("other").value,
                // otherSpecify: document.getElementById("other").value == "1" ? "The parties stipulated to a different amount of child support. Family Code Section 4057(b)(1)" : "",

            })
        }
    };

    return (
        <div className={classes.root}>
            <Stepper activeStep={activeStep} orientation="vertical"
                style={{
                    fontStyle: "normal",
                    fontFamily: "sans-serif",
                    backgroundColor: "white",
                    textAlign: "justify",
                    textJustify: "inter-word",
                    padding: "30px 70px"
                }}
            >
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                        <StepContent>
                            <Typography>{getStepContent(index)}</Typography>
                            <div className={classes.actionsContainer}>
                                <div>
                                    <Button
                                        disabled={activeStep === 0}
                                        onClick={handleBack}
                                        className={classes.button}
                                    >
                                        Back
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleNext}
                                        className={classes.button}
                                    >
                                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                    </Button>
                                </div>
                            </div>
                        </StepContent>
                    </Step>
                ))}
            </Stepper>
            {activeStep === steps.length && (
                <Paper square elevation={0} className={classes.resetContainer}>
                    <Typography>All steps completed - you&apos;re finished</Typography>
                    <div>
                        <Button style={{ backgroundColor: "red", color: "white" }} onClick={handleReset} className={classes.button}>
                            Reset
                        </Button>
                        <Button style={{ backgroundColor: "#3f51b5", color: "white" }} onClick={handleBack} className={classes.button}>
                            Back
                        </Button>
                    </div>
                </Paper>
            )}
            <Button
                style={{ float: "right" }}
                variant="contained"
                color="primary"
                onClick={myFunction}
            >
                Print Form
            </Button>
        </div>
    );

};


const mapDispatchToProps = (dispatch) => {
    return {
        postData: (data) => dispatch(postData(data)),
        childSupportAgreed: (data) => dispatch(childSupportAgreed(data)),
        childSupportPayable: (data) => dispatch(childSupportPayable(data)),
        childSupportFactorPay: (data) => dispatch(childSupportFactorPay(data)),
        childSupportRevised: (data) => dispatch(childSupportRevised(data)),
        childSupportFactor: (data) => dispatch(childSupportFactor(data)),
        childSupportTax: (data) => dispatch(childSupportTax(data)),
        childSupportParentPay: (data) => dispatch(childSupportParentPay(data)),
        childSupportContOption: (data) => dispatch(childSupportContOption(data)),
        childSupportSpecialCircumstance: (data) => dispatch(childSupportSpecialCircumstance(data)),
        childSupportTimeShare: (data) => dispatch(childSupportTimeShare(data)),
        childSupportEqualCustody: (data) => dispatch(childSupportEqualCustody(data)),
        childSupportChildMedicalOther: (data) => dispatch(childSupportChildMedicalOther(data)),
        childSupportOtherSpecify: (data) => dispatch(childSupportOtherSpecify(data)),
        childSupportGetAllData: (data) => dispatch(childSupportGetAllData(data)),

    }
}

const mapStateToProps = (state, ownProps) => ({
    stipulation: state.NonGuideLineReducer.stipulation,
    childSupportCalculate: state.NonGuideLineReducer.childSupportCalculate,
    supportFactor: state.NonGuideLineReducer.supportFactor,
    unjustCase: state.NonGuideLineReducer.unjustCase,
    propertyTaxPay: state.NonGuideLineReducer.propertyTaxPay,
    parentTaxPay: state.NonGuideLineReducer.parentTaxPay,
    ContOption: state.NonGuideLineReducer.ContOption,
    circumstanceSpecial: state.NonGuideLineReducer.circumstanceSpecial,
    childTimeShare: state.NonGuideLineReducer.childTimeShare,
    childEqualCustody: state.NonGuideLineReducer.childEqualCustody,
    childMedicalOpt: state.NonGuideLineReducer.childMedicalOpt,
    otherOpt: state.NonGuideLineReducer.otherOpt,
    filedPetition: state.petitionerPacketReducer.filedPetition,
    petitioner: state.ProfileInformationReducer.petitionerDetails,
    respondent: state.ProfileInformationReducer.respondentDetails,
    court: state.ProfileInformationReducer.court,

});

export default connect(mapStateToProps, mapDispatchToProps)(NonGuideLineChildSupport);
